<div>
    

    <div >
        <div class="Tabletitle">Export Request Details
        </div>
    </div>    
    <div>        
        <mat-form-field class="element-filter" *ngIf="docsList">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)">
        </mat-form-field>
    </div>

    <div *ngIf="noDocuments" class="docmessage card">
        <div class="card-body">
            No export files to display.
        </div>
    </div>

    <div class="container-fluid" *ngIf="!noDocuments">
        
        <div style="margin-top: 1em; margin-bottom: 1em; text-align-last: end">
            <div>
                (Total Count: {{docLength}})
            </div>
        </div> 
        <div class="mat-elevation-z2">
            <button
        mat-stroked-button
        class="btn btn-small"
        title="refresh"
        (click)="refresh()"
        style="vertical-align: middle;"
      >
        <mat-icon title="refresh">refresh</mat-icon>
        </button>
        <table mat-table [dataSource]="docsList" matSort>

            <ng-container matColumnDef="srNum">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                <td mat-cell *matCellDef="let element;let i=index">
                    {{ (i+1) + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
            </ng-container>
            <ng-container matColumnDef="file_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                <td mat-cell *matCellDef="let element"> {{element.file_name}} </td>
            </ng-container>
            <ng-container matColumnDef="creation_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested Date </th> 
                <td mat-cell *matCellDef="let element"> {{element.creation_date | date:'medium'}} </td> 
            </ng-container>
            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested By </th>
                <td mat-cell *matCellDef="let element"> {{element.user}} </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status.status}} </td>
            </ng-container>
            <ng-container matColumnDef="download_link">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Download </th>
                <td mat-cell *matCellDef="let element" style="padding-left: 10px; "> 
                    <a  *ngIf="element.download_link" href="javascript:void(0)" (click)="downloadLink(element.storage_key)" style="color: black; "><mat-icon>file_download</mat-icon></a>
                    <a *ngIf="!element.download_link" href=""></a> </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
            <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row" [class.selected-row]="selectedRow === row" (click)="selectedRow = selectedRow === row ? null : row">
            </tr>
            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

        </table>
        <mat-paginator #myPaginator [pageSizeOptions]="[50, 100]" [pageSize]="50" showFirstLastButtons>
        </mat-paginator>
    </div>
    </div>
